import React, { useState } from "react";
import {
  menuUrl,
  tableTitle,
  keyColumn,
  tableColumn,
  breadCrumbs,
  filters as rawFilters,
} from "@screens/system/database-backup/database-backup-list/model/database-backup-list.constants";
import { getFilterData } from "@utils/common";
import {
  constructFilterDataAndGetQueryString,
  getFilterQueryString,
} from "@utils/filters.util";
import { APP } from "@constants/app.constants";
import { useHistory } from "react-router-dom";
import { checkMenuAccess } from "@utils/menu-auth";
import {
  createDatabaseBackupDataApi,
  deleteDatabaseBackupDataApi,
  getDatabaseBackupDataApi,
} from "./database-backup.component.service";
import MESSAGES from "@constants/messages.constants";
import { useDispatch, useSelector } from "react-redux";
import { setAlertMessage } from "@reducers/alert.reducer";
import { END_POINT } from "@constants/api.constants";
import DatabaseBackupTemplateComponent from "./database-backup-list-template.component";
import PermissionDeniedComponent from "@screens/permission-denied/permission-denied.component";

const {
  ALERT_TYPES: { SUCCESS, ERROR },
  DATABASE_BACKUP_ALERTS: { DELETE_ALERT, CREATE_ALERT },
} = MESSAGES;
const { ROWS_PER_PAGE } = APP;

const DatabaseBackupListComponent = () => {
  const { filterList } = useSelector((state) => state.filter);
  const [tableData, setTableData] = useState([]);
  const [totalCount, setTotalCount] = useState(0);
  const history = useHistory();
  const dispatch = useDispatch();
  const filters = getFilterData(filterList, menuUrl, "filter");
  const menuAccess = checkMenuAccess(menuUrl, "read");
  const { DATABASE_BACKUP_EXPORT } = END_POINT;
  const { token } = useSelector((state) => state.app);

  const getDatabaseBackupData = async (params = null) => {
    // console.log({ params });
    const queryStr = getFilterQueryString(menuUrl, params);
    const databaseBackupData = await getDatabaseBackupDataApi({
      ...params,
      filters: queryStr,
    });
    if (databaseBackupData.status) {
      // console.log(databaseBackupData);
      setTableData(databaseBackupData.data);
      setTotalCount(databaseBackupData.totalCount);
    }
  };

  const handleCreateClick = async () => {
    // history.push(`/${menuUrl}/create`);
    const createResponse = await createDatabaseBackupDataApi();
    // console.log({ createResponse });
    dispatch(setAlertMessage({ type: SUCCESS, message: CREATE_ALERT }));
  };

  const deleteRecords = async (selected) => {
    const deleteAccess = checkMenuAccess(menuUrl, "delete");
    if (deleteAccess) {
      const response = await deleteDatabaseBackupDataApi(selected);
      if (response.status) {
        dispatch(
          setAlertMessage({ type: SUCCESS, message: DELETE_ALERT, viewed: 0 })
        );
        getDatabaseBackupData({
          orderBy: "created_at",
          sortBy: "desc",
          skip: 0,
          limit: ROWS_PER_PAGE,
        });
      } else {
        dispatch(
          setAlertMessage({ type: ERROR, message: response.message, viewed: 0 })
        );
      }
    } else
      dispatch(
        setAlertMessage({
          type: ERROR,
          message: "Permission denied to delete",
          viewed: 0,
        })
      );
  };

  const handleDownload = async (filters = null) => {
    const queryStr = getFilterQueryString(menuUrl, filters);
    // console.log("download triggered", filters, queryStr);
    //// console.log({
    //  url: `${DATABASE_BACKUP_EXPORT}?token=${token}${queryStr}`,
    //});
  };

  const submitFilter = (filters) => {
    const queryStr = constructFilterDataAndGetQueryString(filters, menuUrl);
    // console.log({ queryStr });
    getDatabaseBackupData({
      orderBy: "created_at",
      sortBy: "desc",
      skip: 0,
      limit: ROWS_PER_PAGE,
      filters: queryStr,
    });
  };

  const handleBackupDownloadClick = (filename) => {
    // console.log({ row });
    // console.log("download triggered");
    // console.log({
    //   url: `${DATABASE_BACKUP_EXPORT}?token=${token}&file_name=${row.file_name}`,
    // });
    window.open(
      `${DATABASE_BACKUP_EXPORT}?token=${token}&file_name=${filename}`
    );
    console.log(filename);
  };

  return menuAccess ? (
    <DatabaseBackupTemplateComponent
      templateModal={{
        tableTitle,
        keyColumn,
        breadCrumbs,
        tableColumn: tableColumn({ handleBackupDownloadClick }),
        tableData,
        totalCount,
        filters: filters ? filters : rawFilters,
      }}
      templateEvents={{
        getDatabaseBackupData,
        handleCreateClick,
        deleteRecords,
        handleDownload,
        submitFilter,
      }}
    />
  ) : (
    <PermissionDeniedComponent />
  );
};

export default DatabaseBackupListComponent;
